import { LINE_TAGS, LINE_TYPES } from "@/lib/ManufacturingTags.generated";
import type { IShiftPersonLineRecItem } from "@/lib/backend/manufacturing2.generated.types";
import type { ITags } from "@/lib/models";

type ShiftCellStatus = Pick<IShiftPersonLineRecItem, "enabled" | "has_work"> & {
    worker_hours: number | null;
};

export function getShiftCellStatusCssClass(shift_data: ShiftCellStatus, line_is_ordinary: boolean): string {
    if (!line_is_ordinary) {
        return "";
    }
    if (shift_data.worker_hours === null) {
        return shift_data.enabled ? "" : "shift-disabled";
    }
    if (!shift_data.enabled) {
        return "shift-disabled";
    }
    if (shift_data.worker_hours === 0) {
        return shift_data.has_work ? "shift-zero-norm" : "shift-unallocated";
    }
    return "";
}

export function getLineTitleCssClass(line_tags: ITags): string {
    line_tags = line_tags || {};
    let lineTitleCss = "";
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.line_group_lead) {
        lineTitleCss += " line-linegroup-lead";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.sick_leave) {
        lineTitleCss += " line-sick-leave";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.non_work) {
        lineTitleCss += " line-non-work";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.cameraman) {
        lineTitleCss += " line-cameraman";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.control) {
        lineTitleCss += " line-control";
    }
    if (line_tags[LINE_TAGS.skip_planning] === "true") {
        lineTitleCss += " line-no-planning";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.packaging) {
        lineTitleCss += " line-packaging";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.shift_lead) {
        lineTitleCss += " line-shift-lead";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.tool_setup) {
        lineTitleCss += " line-tool-setup";
    }
    if (line_tags[LINE_TAGS.type] === LINE_TYPES.pool) {
        lineTitleCss += " line-tool-pool";
    }
    return lineTitleCss;
}
